import { render, staticRenderFns } from "./TransportItemCard.vue?vue&type=template&id=099ee696&scoped=true"
import script from "./TransportItemCard.vue?vue&type=script&setup=true&lang=js"
export * from "./TransportItemCard.vue?vue&type=script&setup=true&lang=js"
import style0 from "./TransportItemCard.vue?vue&type=style&index=0&id=099ee696&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "099ee696",
  null
  
)

export default component.exports